import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardHeader, CardContent, CardFooter } from '@/components/ui/card';

interface CardGridSkeletonProps {
  /** Number of cards to show */
  count?: number;
  /** Grid columns configuration */
  columns?: 'auto' | 2 | 3;
}

/**
 * Reusable skeleton grid of cards.
 * Used by Bills, Legislators, and Dashboard pages.
 */
export function CardGridSkeleton({ count = 6, columns = 'auto' }: CardGridSkeletonProps) {
  const gridClass =
    columns === 'auto'
      ? 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4'
      : columns === 2
        ? 'grid grid-cols-1 sm:grid-cols-2 gap-4'
        : 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4';

  return (
    <div className={gridClass}>
      {Array.from({ length: count }).map((_, i) => (
        <Card key={i} className="overflow-hidden">
          <CardHeader className="space-y-2">
            <div className="flex justify-between items-start">
              <Skeleton className="h-5 w-3/4" />
              <Skeleton className="h-5 w-16 rounded-full" />
            </div>
            <Skeleton className="h-4 w-1/2" />
          </CardHeader>
          <CardContent className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </CardContent>
          <CardFooter>
            <Skeleton className="h-9 w-20" />
          </CardFooter>
        </Card>
      ))}
    </div>
  );
}
